export type BrokerNerdsBarkerCoreEnumsPricerStatus = (typeof BrokerNerdsBarkerCoreEnumsPricerStatus)[keyof typeof BrokerNerdsBarkerCoreEnumsPricerStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsPricerStatus = {
  None: 'None',
  AutoPriced: 'AutoPriced',
  AtCeiling: 'AtCeiling',
  AtFloor: 'AtFloor',
  NoComparables: 'NoComparables',
  Errored: 'Errored',
  Scheduled: 'Scheduled',
  AtSoftFloor: 'AtSoftFloor',
  Paused: 'Paused',
  PausedWithWarning: 'PausedWithWarning',
} as const;
